import { IonHeader, IonToolbar, IonButtons, IonGrid, IonTitle } from '@ionic/react';
import React, { useContext } from 'react';
import { AppContext } from '../../../context/app.context';
import ConditionalForm from './ConditionalForm';
import ConditionalLogicButton from './ConditionalLogicButton';

const PHQConditions = () => {

    const appContext = useContext(AppContext);
    const selectedSection = appContext?.questionnaire?.SelectedSection;
    return (
        <div>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="end">
                        <ConditionalLogicButton isBack={true} section={undefined}></ConditionalLogicButton>
                    </IonButtons>
                    <IonTitle> Conditions for section : {selectedSection?.Label}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonGrid>
                <ConditionalForm />
            </IonGrid>
        </div >
    )
}

export default PHQConditions